module.exports = __webpack_public_path__ + "img/kkb_m290_straight.ed8d9c03.jpg";